import React from 'react';
import { PageTemplate } from '@/components/molecules/PageTemplate';

export const Upgrade: React.FC = () => {
  return (
    <PageTemplate
      title="Upgrade"
      description="Upgrade your nCoder AI plan"
    />
  );
};

export default Upgrade;